export default [
  {
    title: 'breadcrumb.report',
    route: 'list-report',
    icon: 'BookIcon',
    resource: 'report',
    action: 'read'
  }
];